<h1>{{ 'MAIN_DASHBOARD.WS_DIRECTORY' | translate }}</h1>

<div class="content-container-search m-t-20">
  <div class="ui-g">
    <div class="ui-g-12">
      <h3 class="text-left">{{ 'TRACK_CHANGES.TITLE' | translate }}</h3>
      <div class="p-grid">
        <div class="p-col-3">
          <label >{{ 'TRACK_CHANGES.SEARCH_BAR.OBJECT_ID' | translate}}</label>
          <input [(ngModel)]="objectId" type="number" pInputText min="1"/>
        </div>
        <div class="p-col-3">
          <label >{{ 'TRACK_CHANGES.SEARCH_BAR.OBJECT_TYPE' | translate}}</label>
          <p-multiSelect
            [(ngModel)]="selectedObjectType"
            [options]="objectTypeOptions"
            optionLabel="translation"
            [filter]="false"
            [showToggleAll]="false"

          >
          </p-multiSelect>
        </div>

        <div class="p-col-3">
          <label >{{ 'TRACK_CHANGES.SEARCH_BAR.AUTHOR' | translate}}</label>
          <p-autoComplete
            [(ngModel)]="selectedAuthor"
            [suggestions]="persons"
            [minLength]="1"
            field="fullName"
            dataKey="id"
            [forceSelection]="true"
            (completeMethod)="filterPersons($event)"
          >
            <ng-template let-item pTemplate="item">
              <span>{{ item.fullName}}</span>
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="p-col-3">
          <label >{{ 'TRACK_CHANGES.SEARCH_BAR.SELECT_PERIOD' | translate}}</label>
          <p-calendar [showIcon]="true"
                      selectionMode="range"
                      dateFormat="dd/mm/yy"
                      [monthNavigator]="true"
                      [yearNavigator]="true"
                      yearRange="2000:2030"
                      [(ngModel)]="dates"
                      [showButtonBar]="true"
          ></p-calendar>
        </div>
      </div>
      <div class="p-grid" style="display: inline-flex; flex-direction: row">
        <div class="p-col-9 inline-flex">
          <p-checkbox
            [(ngModel)]="createCheckbox"
            label="{{ 'TRACK_CHANGES.SEARCH_BAR.CREATE_CHECKBOX' | translate}} "
            binary="true"
            class="inline-flex  m-r-60 "
          >
          </p-checkbox>
          <p-checkbox
            [(ngModel)]="updateCheckbox"
            label="{{ 'TRACK_CHANGES.SEARCH_BAR.UPDATE_CHECKBOX' | translate}} "
            binary="true"
            class="inline-flex m-r-60"
          >
          </p-checkbox>
          <p-checkbox
            [(ngModel)]="deleteCheckbox"
            label="{{ 'TRACK_CHANGES.SEARCH_BAR.DELETE_CHECKBOX' | translate}} "
            binary="true"
            class="inline-flex  m-r-60"
          >
          </p-checkbox>
        </div>
        <div class="p-col-3"></div>
      </div>

      <div class="p-grid">
        <button pButton
                class="ui-button-primary inline-block width-full-parent m-l-5"
                label="{{ 'TRACK_CHANGES.SEARCH_BAR.SEARCH_BUTTON' | translate}} "
                (click)="search(true)">
        </button>

        <button pButton
                class="ui-button-secondary inline-block width-full-parent m-l-10"
                label="{{ 'TRACK_CHANGES.SEARCH_BAR.RESET_BUTTON' | translate}} "
                (click)="reset()">
        </button>
      </div>
    </div>
  </div>
</div>

<div class="result" *ngIf="trackChangesResponse">
  <div class="ui-g">
    <div class="ui-g-12">
      <div class="p-grid">
        <div class="p-col-12">
          <h3 > {{trackChangesResponse.allItemsSize}} {{ 'TRACK_CHANGES.FOUND_RESULTS' | translate}}</h3>
          <p-accordion multiple="true" expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up">
            <p-accordionTab cache *ngFor="let trackChange of trackChangesResponse.changeLogDataList">
              <p-header>
                <div class="p-grid accord-header-content">
                  <div class="p-col-3">
                    <label class="accord-p"> {{getTranslationFromObjectTypeOptions(trackChange.objectType)}} </label>
                    <p class="accord-p"> {{trackChange.objectName}} </p>
                  </div>
                  <div class="p-offset-6 p-col-3 p-r-20">
                    <div class="inline-flex flr">
                      <p class="accord-p {{getChangeColorClass(trackChange)}} ">{{getActionTypeTranslation(trackChange)}}</p>
                      &nbsp;{{'TRACK_CHANGES.ACCORDION.BY' | translate }}
                      <label class="m-l-5">{{getFullName(trackChange)}}</label>
                    </div>
                    <div class="inline flr">
                      {{getFormattedDate(trackChange.creationDate)}}
                    </div>
                  </div>
                </div>
              </p-header>

              <ng-template pTemplate="content">
                <wsd-track-change [id]="trackChange.id"
                                  [actionType]="trackChange.actionType"
                                  [objectType]="trackChange.objectType"
                ></wsd-track-change>
              </ng-template>
            </p-accordionTab>
          </p-accordion>
          <p-paginator *ngIf="trackChangesResponse.allItemsSize > pageSize"
                       [rows]="pageSize"
                       [totalRecords]="trackChangesResponse.allItemsSize"
                       (onPageChange)="onPageChange($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
